<template>
    <table :style="tableStyle" class="pure-table-bordered">
        <thead :style="theadStyle">
            <tr>
              <th :style="{
                width: widthObj ? `${widthObj[key] * 10}%` : 'auto'
              }" v-for="(item, key, index) in thDatas" :key="index">
                  {{ item }}
              </th>
            </tr>
        </thead>
        <tbody @mousewheel.stop :style="tbodyStyle">
            <tr v-for="(thItem, i) in tdDatas" :key="thItem.id + i">
              <td
                v-for="(item, key, index) in thDatas"
                :key="'th' + index"
                :style="{
                  padding: '0.1rem 0.1rem',
                  width: widthObj ? `${widthObj[key] * 10}%` : 'auto',
                  ...tdStyle,
                  ...getTdStyle?.(i, index)
                }"
              >
                <slot :value="thItem[key]" :index="index"></slot>
                <span v-html="thItem[key]"></span>
              </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'Table',
    props:{
        tableStyle: Object,
        theadStyle: Object,
        tbodyStyle: Object,
        thDatas: Object,
        tdDatas: Array,
        widthObj: Object,
        tdStyle: Object,
        getTdStyle: Function
    },
    data(){
        return{
        }
    },
}
</script>
<style lang="less" scoped>
td{
  color: #fff;
}
tbody::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
  display: none;
}
tbody::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: #272525;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent 100%
  );
}
tbody::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.pure-table-bordered {
  z-index: 2;
  // display: grid;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #02d9fd;
  width: 100%;
  // height: 3.5rem;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: center;
  tbody{
    scrollbar-width: none;
    overflow-x: none;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    scrollbar-width: none;
    // max-height: calc(3.5rem - 0.48rem);
    display: block;
    // &:hover{
    //   // width: calc(100% + 3px);
    //   // &::-webkit-scrollbar{
    //   //   display: block;
    //   // }
    // }
  }
  tr{
    width: 100%;
    display: table;
    table-layout: fixed;
    box-sizing: border-box;
  }
  th,
  td {
    border: 1px solid #517FB5;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }
  }
  th {
    font-size: 0.15rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #02d9fd;
    padding: 0.13rem 0;
    // border-bottom: none;
  }
  td {
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    border-bottom: none;
    word-wrap:break-word;
    box-sizing: border-box;
  }
  tr:first-child th {
    border-top: none;
  }
  tr:last-child td{
    border-bottom: 1px solid #517FB5;
  }
  // tr:last-child td {
    // border-bottom: none;
  // }
}
</style>